import { subscribeLive } from "@/api/live";
import { useCallback, useRef, useState } from "react";
// import { useLocation } from "react-router-dom";
import { Toast } from "antd-mobile";

export default function useSubscribe({ liveType }) {
  // 订阅需要用到的相关数据
  const subscribeInfo = useRef(null);
  // 接口返回的公众号二维码链接
  const [subscribeLink, setSubscribeLink] = useState("");
  // 是否拉起公众号二维码弹窗
  const [showSubscribePop, setShowSubscribePop] = useState(false);
  // 订阅成功后的回调
  const subscribeSuccessCbk = useRef(null);

  /**
   * 订阅开播提醒，查询公众号二维码地址，拉起二维码弹窗
   * @param {Object} preheatInfo - 直播预告数据
   * @param {Number} index - 直播列表的索引
   */
  const handleSubscribeMixin = async ({ preheatInfo, index, successCbk }) => {
    if (!preheatInfo) {
      return;
    }

    subscribeInfo.current = preheatInfo;

    let brandName = "";
    if (preheatInfo.activityList && preheatInfo.activityList.length) {
      [{ brandName }] = preheatInfo.activityList;
    } else {
      brandName = preheatInfo.hostNickName;
    }

    if (preheatInfo.shareType === "schoolLive") {
      brandName = preheatInfo.liveCreatorNickName;
    }

    const query = {
      playBeginTime: preheatInfo.planBeginTime,
      liveTitle: preheatInfo.liveTitle,
      liveNo: preheatInfo.liveNo,
      channel: "20",
      urlType: 1,
      brandName,
      liveType,
      shareType: preheatInfo.shareType || "liveing",
    };
    try {
      const res = await subscribeLive(query);
      const { qrCodeUrl } = res;
      // 拉起关注公众号二维码弹窗
      if (qrCodeUrl) {
        setSubscribeLink(qrCodeUrl);
        setShowSubscribePop(true);
      } else {
        Toast.show("订阅成功！");
        successCbk && successCbk();
      }
    } catch (err) {
      console.error(err);
      Toast.show(err.message || "服务异常，请稍后重试！");
    }
  };

  //   const getSubscribeStatus = useCallback(() => {
  //     if (!subscribeInfo) {
  //       return Promise.reject(new Error("No subscribe info set"));
  //     }

  //     const queryParams = new URLSearchParams(location.search);
  //     const routeLiveType = queryParams.get("liveType");

  //     return subscribeLive({
  //       liveNo: subscribeInfo.liveNo,
  //       channel: "20",
  //       urlType: 2,
  //       liveType: routeLiveType || 10,
  //       shareType: subscribeInfo.shareType || "liveing",
  //     });
  //   }, [location.search, subscribeInfo]);

  return {
    //     subscribeInfo,
    subscribeLink,
    //     isSubscribed,
    showSubscribePop,
    setShowSubscribePop,
    handleSubscribeMixin,
    //     getSubscribeStatus,
    subscribeSuccessCbk,
  };
}
